/**
 * Angular distance between two angles in degrees (0-360).
 * Returns the shortest arc between them.
 */
export function anglesDistance(a: number, b: number): number {
  return Math.min(Math.abs(a - b), 360 - Math.abs(a - b));
}

/**
 * Euclidean distance between two vectors of equal length.
 * Used for face descriptor comparison.
 */
export function euclideanDistance(
  a: ArrayLike<number>,
  b: ArrayLike<number>,
): number {
  if (a.length !== b.length) {
    throw new Error("euclideanDistance: arr1.length !== arr2.length");
  }
  let sum = 0;
  for (let i = 0; i < a.length; i++) {
    const diff = a[i] - b[i];
    sum += diff * diff;
  }
  return Math.sqrt(sum);
}
